export const relatorioPorEmpresas = 'RelatorioPorEmpresas';
export const relatorioPorVendedores = 'RelatorioPorVendedores';
export const relatorios = [relatorioPorEmpresas, relatorioPorVendedores];
export const relatoriosTipos = {
  [relatorioPorEmpresas]: 1,
  [relatorioPorVendedores]: 2
};
